<div class="tarification-header" ng-class="{'tarification-header-full-height': useMaxHeight}"
     data-e2e="e2e-container-tarification-header">
    <table class="first-table">
        <tr>
            <td>
                <div class="align-center">
                    <div class="tarification-header__title">
                        <ng-container *ngIf="offerId; else showTarification">
                            <ng-container *ngIf="showLink; else noLink">
                                <a class="add-margin link"
                                   *ngIf="!isResultPage"
                                   (click)="updateUrlWithOfferId(offerId)">  {{wording.optimisationTitle}}&nbsp;
                                    <ng-container *ngTemplateOutlet="otherInfos"></ng-container>
                                </a>
                                <a class="add-margin link"
                                   *ngIf="isResultPage"
                                   [routerLink]="['/sasha', 'booking', bookingSyscode, offerId]">{{wording.optimisationTitle}}&nbsp;
                                    <ng-container *ngTemplateOutlet="otherInfos"></ng-container>
                                </a>
                            </ng-container>

                            <ng-template #noLink>
                                <span *ngIf="offerId">{{wording.optimisationTitle}}&nbsp;</span>
                                <span class="add-margin" *ngIf="!offerId">  {{priceTitle}}</span>
                                <ng-container *ngTemplateOutlet="otherInfos"></ng-container>
                            </ng-template>

                            <ng-template #otherInfos>
                                <span *ngIf="optimisationType">{{optimisationType}}</span>
                                <span *ngIf="price[costOrRetail]?.whenCreated?.date"> - {{price[costOrRetail]?.whenCreated?.date}}</span>
                            </ng-template>
                        </ng-container>
                        <ng-template #showTarification>
                            <span *ngIf="showLink && !isFee; else noLink">
                                <span class="add-margin link"
                                      (click)="onPriceSelect.emit(price[costOrRetail].xId)">{{priceTitle}}
                                </span>
                                    &nbsp;<sectors-air-simple-list
                                        class="sectors"
                                        [sectors]="sectors"></sectors-air-simple-list>
                                <ng-container *ngTemplateOutlet="otherInfos"></ng-container>
                            </span>
                        </ng-template>

                        <ng-template #noLink>
                            <span class="add-margin">{{priceTitle}}&nbsp;
                                <sectors-air-simple-list
                                           class="sectors"
                                           [sectors]="sectors"></sectors-air-simple-list>&nbsp;
                            </span>
                            <ng-container *ngTemplateOutlet="otherInfos"></ng-container>
                        </ng-template>
                        <ng-template #otherInfos>
                            <span *ngIf="price[costOrRetail]?.xState && !isFee">&nbsp;-&nbsp;{{price[costOrRetail]?.xState}}</span>
                            <span *ngIf="price[costOrRetail]?.whenCreated?.date">&nbsp;-&nbsp;{{price[costOrRetail]?.whenCreated?.date}}</span>
                        </ng-template>

                    </div>
                    <a *ngIf="!showReturnBtn"
                         class="btn-right-align returnLink"
                         (click)="hideSelectedRate()">
                        {{wording.labelReturn}}
                    </a>
                </div>
            </td>
            <td>
                <div class="tarification-header__price">
                    <span *ngFor="let priceTotal of pricesTotal;"
                          [innerHTML]="priceTotal.value | price:priceTotal.currencyCode"></span>
                    <ng-container *ngIf="savingTotal">
                        (<span class="price-difference"
                               [innerHTML]="savingTotal.value | price:savingTotal.currencyCode"></span>)
                    </ng-container>
                </div>
            </td>
        </tr>
        <tr>
            <td class="first-td" colspan="2">
                <tarification-header-transportation *ngIf="price[costOrRetail]?.xRole === eRateType.Transportation"
                                                    [price]="price"
                                                    [booking]="booking"
                                                    [savingPrice]="savingPrice"
                                                    [costOrRetail]="costOrRetail"
                                                    [differences]="differences"
                                                    [tarificationPrice]="tarificationPrice"
                                                    [whenLastUpdated]="whenLastUpdated"
                >
                </tarification-header-transportation>
                <tarification-header-service *ngIf="price[costOrRetail]?.xRole === eRateType.Service"
                                             [price]="price"
                                             [costOrRetail]="costOrRetail"
                                             [booking]="booking"></tarification-header-service>
            </td>
        </tr>
    </table>
</div>
